import { render, staticRenderFns } from "./ProjectTodoList.vue?vue&type=template&id=49937222&scoped=true"
import script from "./ProjectTodoList.vue?vue&type=script&lang=js"
export * from "./ProjectTodoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49937222",
  null
  
)

export default component.exports